import { render, staticRenderFns } from "./ApprovalProposalLpj.vue?vue&type=template&id=0f820c8a&scoped=true"
import script from "./ApprovalProposalLpj.vue?vue&type=script&lang=js"
export * from "./ApprovalProposalLpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f820c8a",
  null
  
)

export default component.exports